import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['constructionlog'], // 为了获取基础路由
    };
};
//  // construction-log
export const constructionLogToPathNameMap = {
    constructionlog1010: ({ businessKey }) => commonFunc(`/constructionlogList/detail/?id=${businessKey}`),
};
